import { RequestType } from "./RequestType";
import { SynchronizationStatus } from "./SynchronizationStatus";

export interface RequestDepartmentProgramSearch {
  schoolYearId: number;
  enrollmentInstitutionId: number;
  requestType?: RequestType;
  synchronizationStatus?: SynchronizationStatus;

  departmentId?: number;
  enrollmentProgramId?: number;
  /*
        public int SchoolYearId { get; init; }
        public int EnrollmentInstitutionId { get; init; }
        public RequestTypeEnum? RequestType { get; init; }
        public SynchronizationStatusEnum? SynchronizationStatus { get; init; }

        public int? DepartmentId {  get; init; }
        public int? EnrollmentProgramId { get; init; }
    */
}

export enum RequestDepartmentProgramSort {
  LastName = 1,
  Birthday = 2,
  Type = 3,
}
